import { useSesion } from '../estado/SesionContext';

/**
 * Honestidad con quien usa la app: en fase 0 el avance no sale de este equipo.
 *
 * Desaparece solo cuando el repo diga que persiste en el servidor, así que en fase 1 no
 * hay que acordarse de quitarlo — que es justo la clase de aviso que se queda pegado.
 */
export function AvisoFase0() {
  const { repo } = useSesion();
  if (!repo || repo.persisteEnServidor()) return null;

  return (
    <p className="mx-auto mt-3 max-w-3xl rounded-xl border border-borde bg-white/70 px-4 py-2 text-center text-xs leading-snug text-gris">
      Versión de demostración: tu avance se guarda en este dispositivo y todavía no se registra
      en el sistema.
    </p>
  );
}
